module.exports = __webpack_public_path__ + "r-v3/img/ico_heart_red.de0ac4e6.svg";